import React from "react";
import "./InformativeText.scss";

/**
 * Componente para mostrar texto informativo con estilos destacados
 * @param {Object} props - Props del componente
 * @param {React.ReactNode} props.children - Contenido del componente
 * @param {string} props.className - Clases CSS adicionales
 * @returns {JSX.Element} Componente TextoInformativo
 */
export const InformativeText = ({ children, className = "", ...props }) => {
  return (
    <div className={`informative-text ${className}`.trim()} {...props}>
      {children}
    </div>
  );
};
